import React from 'react';
import Skeleton from 'react-loading-skeleton';

export const CustomCardSkeleton = () => {
  return <Skeleton height={250} />;
};
